// extracted by mini-css-extract-plugin
export default {"icon-wrap":"q2FQ4"};